import { render, staticRenderFns } from "./register-form3.vue?vue&type=template&id=303c5a4a&scoped=true&"
import script from "./register-form3.vue?vue&type=script&lang=ts&"
export * from "./register-form3.vue?vue&type=script&lang=ts&"
import style0 from "./register-form3.vue?vue&type=style&index=0&id=303c5a4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303c5a4a",
  null
  
)

export default component.exports